const units = {}
export default units

import * as Preact from "preact"
import elements from "@frog/source/data/elements.js"
import items from "@frog/source/data/games/dice/data/items.jsx"

// "2": {"title": "Warhammer", "description": "Attack for **N**, and Push for **N**", "icon": require("@frog/source/assets/images/dice-tactics/actions/thor-hammer.png"), "element": "earth", "skillKeys": ["attack"], "properties": ["forceful"], "attackrange": 1, "power": 20},
// "3": {"title": "Warhammer", "description": "Attack for **N**, and Push for **N**", "icon": require("@frog/source/assets/images/dice-tactics/actions/thor-hammer.png"), "element": "earth", "skillKeys": ["attack"], "properties": ["forceful"], "attackrange": 1, "power": 30},
// "5": {"title": "Fumble!!", "description": "Whoops...", "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")},
// "2": {"title": "Shield Bash", "description": "Attack for **N**, or Defend for **N**", "icon": require("@frog/source/assets/images/dice-tactics/actions/armor-upgrade.png"), "element": "fire", "skillKeys": ["inflict-damage", "armor-up"], "attackrange": 1, "power": 30},
// "3": {"title": "Shield Bash", "description": "Attack for **N**, or Defend for **N**", "icon": require("@frog/source/assets/images/dice-tactics/actions/armor-upgrade.png"), "element": "fire", "skillKeys": ["inflict-damage", "armor-up"], "attackrange": 1, "power": 30},
// "4": {"title": "Greataxe", "description": "Attack for **N**, or Push for **N**", "icon": require("@frog/source/assets/images/dice-tactics/actions/sharp-axe.png"), "element": "earth", "skillKeys": ["inflict-damage", "push"], "attackrange": 1, "power": 10},
// "5": {"title": "Greataxe", "description": "Attack for **N**, or Push for **N**", "icon": require("@frog/source/assets/images/dice-tactics/actions/sharp-axe.png"), "element": "earth", "skillKeys": ["inflict-damage", "push"], "attackrange": 1, "power": 10},
// "1": {"title": "Fumble!!", "description": "Whoops...", "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")},
// "3": {"title": "Fumble!!", "description": "Whoops...", "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")},
// "5": {"title": "Fumble!!", "description": "Whoops...", "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")},

// "1": {"title": "Fumble!!", "description": "Whoops...", "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")},
// "3": {"title": "Fumble!!", "description": "Whoops...", "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")},
// "5": {"title": "Fumble!!", "description": "Whoops...", "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")},

// "1": {"title": "Dodge", "description": "Take no damage, from any attacks", "icon": require("@frog/source/assets/images/dice-tactics/actions/divert.png"), "skillKeys": ["inflict-damage"], "properties": ["dodging"]},
// "3": {"title": "Dodge", "description": "Take no damage, from any attacks", "icon": require("@frog/source/assets/images/dice-tactics/actions/divert.png"), "skillKeys": ["inflict-damage"], "properties": ["dodging"]},
// "5": {"title": "Dodge", "description": "Take no damage, from any attacks", "icon": require("@frog/source/assets/images/dice-tactics/actions/divert.png"), "skillKeys": ["inflict-damage"], "properties": ["dodging"]},

// "0": {"title": "Herald Shield", "description": "Defend for 1, or Attack for 1, Engarde", "icon": require("@frog/source/assets/images/dice-tactics/actions/dragon-shield.png"), "element": "water", "skillKeys": ["inflict-damage"], "properties": ["engage"], "power": 10, "attackrange": 1},
// "4": {"title": "Dagger", "description": "Attack for 1, and Decrease power by 1", "icon": require("@frog/source/assets/images/dice-tactics/actions/plain-dagger.png"), "element": "fire", "skillKeys": ["inflict-damage"], "properties": ["weaken"], "power": 10, "attackrange": 1},
// "5": {"title": "Dagger", "description": "Attack for 1, and Decrease power by 1", "icon": require("@frog/source/assets/images/dice-tactics/actions/plain-dagger.png"), "element": "fire", "skillKeys": ["inflict-damage"], "properties": ["weaken"], "power": 10, "attackrange": 1},
// {"title": "Scythe", "description": "Attack for 2, all tiles around you", "icon": require("@frog/source/assets/images/dice-tactics/actions/scythe.png"), "element": "water", "skillKeys": ["inflict-damage"], "power": 20, "attackrange": 2}, // TODO: peircing aoe

// "2": {"title": "Trumpet", "description": "Attack for 3, or Buff power by 3, (until end of turn)", "icon": require("@frog/source/assets/images/dice-tactics/actions/trumpet.png"), "element": "earth", "skillKeys": ["inflict-damage", "buff"], "power": 30, "attackrange": 1},
// "4": {"title": "Hat", "description": "Attack for 1, or Refresh an ally", "icon": require("@frog/source/assets/images/dice-tactics/actions/top-hat.png"), "element": "earth", "skillKeys": ["inflict-damage", "rally"], "power": 10, "attackrange": 1},
// "5": {"title": "Cape", "description": "Attack for 1, or Buff speed by 1, (until end of turn)", "icon": require("@frog/source/assets/images/dice-tactics/actions/cape.png"), "element": "earth", "skillKeys": ["inflict-damage", "speedup"], "properties": ["dice/speedup"], "power": 10, "attackrange": 1},
// "1": {"title": "Fumble!!", "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")},
// {"title": "Fireball", "icon": require("@frog/source/assets/images/dice-tactics/actions/flame.png"), "element": "fire", "skillKeys": ["inflict-damage"], "power": 20, "attackrange": 1}, // TODO: aoe
// {"title": "Confuse", "icon": require("@frog/source/assets/images/dice-tactics/actions/star-swirl.png"), "element": "earth", "skillKeys": ["inflict-damage"], "power": 30, "attackrange": 1}, // TODO: stun
// {"title": "Fumble!!", "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")},

const DEFAULT_MONSTER = {
    "maxhealth": 50,
    "defense": 0,
    "resistance": 0,
    "moverange": 2,

    "affiliation": "bad",
    "state": "aggroed",

    // "title": "???",
    // "subtitle": "Monstrosity",

    "spriteSize": "4x3",
    "weaponImageKey": "hidden",
    "weaponAudioKey": "Unit:Attack:Monster",
}

units["monster/slime/water"] = {
    ...DEFAULT_MONSTER,
    "title": "Ice Slime",

    "maxhealth": 30,
    "moverange": 1,
    "attackaudio": "Attack:Slime",
    "diceFaces": [
        {...items["slime-pentapod"], "element": "water", "power": 10},
        {...items["slime-pentapod"], "element": "water", "power": 10},
        {...items["slime-pentapod"], "element": "water", "power": 10},
        {...items["slime-pentapod"], "element": "water", "power": 10},
        {...items["slime-pentapod"], "element": "water", "power": 20},
        {...items["slime-pentapod"], "element": "water", "power": 20},
    ],

    "sprites": {
        "idle": {
            "frames": [
                {"time": 0.000, "image": require("@frog/source/assets/images/dice-tactics/slimepink1.png")},
                {"time": 125*1, "image": require("@frog/source/assets/images/dice-tactics/slimepink2.png")},
                {"time": 125*2, "image": require("@frog/source/assets/images/dice-tactics/slimepink3.png")},
                {"time": 125*3, "image": require("@frog/source/assets/images/dice-tactics/slimepink4.png")},
                {"time": 125*4, "image": require("@frog/source/assets/images/dice-tactics/slimepink3.png")},
            ]
        },
    },
}

units["monster/slime/earth"] = {
    ...DEFAULT_MONSTER,
    "title": "Earth Slime",

    "maxhealth": 30,
    "moverange": 1,
    "attackaudio": "Attack:Slime",
    "diceFaces": [
        {...items["slime-pentapod"], "element": "earth", "power": 10},
        {...items["slime-pentapod"], "element": "earth", "power": 10},
        {...items["slime-pentapod"], "element": "earth", "power": 10},
        {...items["slime-pentapod"], "element": "earth", "power": 10},
        {...items["slime-pentapod"], "element": "earth", "power": 20},
        {...items["slime-pentapod"], "element": "earth", "power": 20},
    ],

    "sprites": {
        "idle": {
            "frames": [
                {"time": 0.000, "image": require("@frog/source/assets/images/dice-tactics/slimegreen1.png")},
                {"time": 125*1, "image": require("@frog/source/assets/images/dice-tactics/slimegreen2.png")},
                {"time": 125*2, "image": require("@frog/source/assets/images/dice-tactics/slimegreen3.png")},
                {"time": 125*3, "image": require("@frog/source/assets/images/dice-tactics/slimegreen4.png")},
                {"time": 125*4, "image": require("@frog/source/assets/images/dice-tactics/slimegreen3.png")},
            ]
        },
    },
}

units["monster/slime/fire"] = {
    ...DEFAULT_MONSTER,
    "title": "Fire Slime",

    "maxhealth": 30,
    "moverange": 1,
    "attackaudio": "Attack:Slime",
    "diceFaces": [
        {...items["slime-pentapod"], "element": "fire", "power": 10},
        {...items["slime-pentapod"], "element": "fire", "power": 10},
        {...items["slime-pentapod"], "element": "fire", "power": 10},
        {...items["slime-pentapod"], "element": "fire", "power": 10},
        {...items["slime-pentapod"], "element": "fire", "power": 20},
        {...items["slime-pentapod"], "element": "fire", "power": 20},
    ],
    "sprites": {
        "idle": {
            "frames": [
                {"time": 0.000, "image": require("@frog/source/assets/images/dice-tactics/slimeorange1.png")},
                {"time": 125*1, "image": require("@frog/source/assets/images/dice-tactics/slimeorange2.png")},
                {"time": 125*2, "image": require("@frog/source/assets/images/dice-tactics/slimeorange3.png")},
                {"time": 125*3, "image": require("@frog/source/assets/images/dice-tactics/slimeorange4.png")},
                {"time": 125*4, "image": require("@frog/source/assets/images/dice-tactics/slimeorange3.png")},
            ]
        },
    },
}

units["monster/slime/queen"] = {
    ...DEFAULT_MONSTER,
    "title": "Slime Queen",
    "name": "Slime Queen",
    "jobName": "Regent of the Ooze",

    "maxhealth": 90,
    "properties": ["boss"],
    "moverange": 1,
    "attackaudio": "Attack:Slime",
    "diceFaces": [
        {...items["slime-pentapod"], "element": "fire", "power": 20},
        {...items["slime-pentapod"], "element": "water", "power": 20},
        {...items["slime-pentapod"], "element": "earth", "power": 20},
        {...items["slime-pentapod"], "element": "fire", "power": 30},
        {...items["slime-pentapod"], "element": "water", "power": 30},
        {...items["slime-pentapod"], "element": "earth", "power": 30},
    ],

    "sprites": {
        "idle": {
            "frames": [
                {"time": 0.000, "image": require("@frog/source/assets/images/dice-tactics/slimequeen1.png")},
                {"time": 125*1, "image": require("@frog/source/assets/images/dice-tactics/slimequeen2.png")},
                {"time": 125*2, "image": require("@frog/source/assets/images/dice-tactics/slimequeen3.png")},
                {"time": 125*3, "image": require("@frog/source/assets/images/dice-tactics/slimequeen4.png")},
                {"time": 125*4, "image": require("@frog/source/assets/images/dice-tactics/slimequeen3.png")},
            ]
        },
    },
}

units["monster/skeleton"] = {
    ...DEFAULT_MONSTER,
    "title": "Skeleton",
    "maxhealth": 50,

    "attackaudio": "Attack:Skeleton",
    "diceFaces": [
        {...items["skeleton-sword"], "power": 10},
        {...items["skeleton-sword"], "power": 20},
        {...items["skeleton-sword"], "power": 20},
        {...items["skeleton-sword"], "power": 20},
        {...items["skeleton-sword"], "power": 20},
        {...items["skeleton-sword"], "power": 30},
    ],
    "sprites": {
        "idle": {
            "frames": [
                {"time": 0.000, "image": require("@frog/source/assets/images/dice-tactics/skeleton1.png")},
                {"time": 125*1, "image": require("@frog/source/assets/images/dice-tactics/skeleton2.png")},
                {"time": 125*2, "image": require("@frog/source/assets/images/dice-tactics/skeleton3.png")},
                {"time": 125*3, "image": require("@frog/source/assets/images/dice-tactics/skeleton4.png")},
                {"time": 125*4, "image": require("@frog/source/assets/images/dice-tactics/skeleton3.png")},
            ]
        },
    },
}

units["monster/goblin"] = {
    ...DEFAULT_MONSTER,
    "title": "Goblin",
    "maxhealth": 50,

    "attackaudio": "Attack:Goblin",
    "diceFaces": [
        {...items["goblin-bow"], "power": 10},
        {...items["goblin-bow"], "power": 10},
        {...items["goblin-bow"], "power": 10},
        {...items["goblin-bow"], "power": 10, "element": "fire"},
        {...items["goblin-bow"], "power": 10, "element": "fire"},
        {...items["goblin-bow"], "power": 10, "element": "fire"},
    ],
    "sprites": {
        "idle": {
            "frames": [
                {"time": 0.000, "image": require("@frog/source/assets/images/dice-tactics/goblin1.png")},
                {"time": 125*1, "image": require("@frog/source/assets/images/dice-tactics/goblin2.png")},
                {"time": 125*2, "image": require("@frog/source/assets/images/dice-tactics/goblin3.png")},
                {"time": 125*3, "image": require("@frog/source/assets/images/dice-tactics/goblin4.png")},
                {"time": 125*4, "image": require("@frog/source/assets/images/dice-tactics/goblin3.png")},
            ]
        },
    },
}
